/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementEditLivecarpResponse } from './LiveManagementEditLivecarpResponse';

export type LiveManagementEditLivecarpResponseApiRespoonse = {
    data?: LiveManagementEditLivecarpResponse;
    status?: LiveManagementEditLivecarpResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementEditLivecarpResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

